import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ThisDriversCurrentTradeplates from './this-drivers-current-tradeplates.jsx';
import ThisDriversArchivedTradeplates from './this-drivers-archived-tradeplates.jsx';

export default class DriverTradeplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: props.data || [],
      expanded: false,
      newTradeplateFormVisible: false,
      play: false,
      selected_start_date:null,
      selected_end_date:null
    };

    this.handleButtonClicked = this.handleButtonClicked.bind(this);
    this.handleAddNewTradeplateFormSubmitButtonClick = this.handleAddNewTradeplateFormSubmitButtonClick.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleTotalAmountUpdate = this.handleTotalAmountUpdate.bind(this);
    this.handlePaidAmountUpdate = this.handlePaidAmountUpdate.bind(this);
  }

  handleButtonClicked(variable) {
    $("#driver-expanded-tradeplates-list-"+variable).slideToggle(200);
    this.setState({expanded: !this.state.expanded})
  }
  handleStartDateChange(date) {
    this.setState({selected_start_date: date})
  }
  handleEndDateChange(date) {
    this.setState({selected_end_date: date})
  }

  handleAddNewTradeplateButtonClick() {
    this.setState({
      newTradeplateFormVisible: !this.state.newTradeplateFormVisible
    });
  }

  handleAddNewTradeplateFormSubmitButtonClick(e) {
    e.preventDefault();
    let that = this;
    let addNewExcessData = {
      api_token: window.api_token,
      driver_id: this.state.data.driver.id,
      description: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=description]'
      ).val(),
      insurance_reference: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=insurance_reference]'
      ).val(),
      original_amount_to_repay: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=original_amount_to_repay]'
      ).val(),
      deduction_occurance: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=deduction_occurance]'
      ).val(),
      agreed_deduction_amount: $(
        'form#new_excess_for_user'+this.state.data.id+
        ' [name=agreed_deduction_amount]'
      ).val(),
      start_date: (moment(this.state.selected_start_date).isValid()) ? moment(this.state.selected_start_date).format("YYYY-MM-DD"):null,
      end_date: (moment(this.state.selected_end_date).isValid()) ? moment(this.state.selected_end_date).format("YYYY-MM-DD") : null
    };

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/drivers/tradeplates/add-new-tradeplate',
      data: addNewExcessData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status == 200) {
          $('#infomodallabel').html('New Tradeplate Created');
          $('#infomodal .modal-body').html('New Tradeplate Created');
          $('#infomodal').modal();
          $('input').val('');
          $('textarea').val('');
          $('select').val('');

          that.handleAddNewTradeplateButtonClick();
          that.accessChild();
          let total = parseInt(that.state.data.tradeplate_total_amount) + parseInt(addNewExcessData.original_amount_to_repay);
          that.state.data.tradeplate_total_amount = total;
          that.setState({data:that.state.data});
        }
        else {
          $('#infomodallabel').html('Error adding new tradeplaterental');
          $('#infomodal .modal-body').html($.parseHTML(
            response.responseText.
            replace(/\"/g, ""))
          );
          $('#infomodal').modal();
        }
      }
    });
  }
  handleTotalAmountUpdate(total){
    this.state.data.tradeplate_total_amount = total;
    this.setState({data:this.state.data});
  }
  handlePaidAmountUpdate(total){
    this.state.data.tradeplate_total_paid_amount = total;
    this.setState({data:this.state.data});
  }
  accessChild(){
    this.refs.child.handleTradeplatesTableRefresh();
    this.refs.child.handleTradeplatesTableRefresharc();
  }
  componentDidMount() {
    this.setState({
      play: true
    });
  }


  render() {
    return (
      <div className={"driver-tradeplate-account-container"+
      (this.state.expanded ? ' tradeplate-container-expanded ' : '')}>
         <div
          className="row"
          onDoubleClick={() => {
              this.handleButtonClicked(this.state.data.id)
          }}>
          <div className="col-md-1 text-left">
            <img
              src={"/user-images/"+this.state.data.id}
              className="driver-tradeplates-table-driver-image"
            />
          </div>

          <div className="col-md-4">
            <h3>
              <a href={"/portal-admin/users/view/"+this.state.data.id}>
                {this.state.data.first_name} {this.state.data.last_name}
              </a>
            </h3>
          </div>

          <div className="col-md-5">
            <h3>
            &pound;{this.state.data.tradeplate_total_paid_amount} /
            &pound;{this.state.data.tradeplate_total_amount}
            </h3>
          </div>

          <div className="col-md-2 text-right">
            <button
              onClick={(e) => {
                this.handleButtonClicked(this.state.data.id)
              }}
              className="btn btn-lg btn-default">
              Tradeplaterentals {(this.state.expanded ?
                <i className="fa fa-times"></i>:
                <i className="fa fa-level-down-alt"></i>)}
            </button>
          </div>
        </div>

        <div
          className="container driver-expanded-tradeplates-list"
          id={"driver-expanded-tradeplates-list-"+this.state.data.id}>
          <div className="row">
          <div className="col-md-6">
          <div className="row">
          <div className="col-md-6">
            <h2>Current Tradeplaterentals</h2>
          </div>
          <div className="col-md-6">
          <button className="btn btn-sm btn-dark"
               onClick={(e) => {
                 this.handleAddNewTradeplateButtonClick(this.state.data.id)
               }}>
              {(this.state.newTradeplateFormVisible ?
                <i className="fa fa-minus"></i>:
                <i className="fa fa-plus"></i>)
              } Add New Tradeplate
              </button>
            </div>
            </div>

          {(this.state.newTradeplateFormVisible ?
            <Animate
              play={this.state.play}
              start={{opacity: 0}}
              end={{opacity: 1}}
              className="driver-excess-form-container"
            >
            <form id={"new_excess_for_user"+this.state.data.id}>
              <fieldset>
                  <div className="row">
                    <div className="col-md-6 text-right">
                      Description
                    </div>
                    <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="description"
                    type="text" placeholder="description" />
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6 text-right">
                    Reference
                    </div>
                    <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="insurance_reference"
                    type="text" placeholder="reference" />
                    </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 text-right">
                        Amount to Repay:
                      </div>
                      <div className="col-md-6 text-left">
                    <input
                    className="form-control form-control-lg"
                    name="original_amount_to_repay"
                     type="text" placeholder="&pound;amount" />
                   </div>
                    </div>
                <div className="row">
                    <div className="col-md-6 text-right">
                    @
                    </div>
                    <div className="col-md-6 text-left">
                      <input type="text" placeholder="&pound;amount"
                      name="agreed_deduction_amount"
                      className="form-control" />
                     per <select name="deduction_occurance">
                      <option value="weekly">Week</option>
                      <option value="monthly">Month</option>
                      <option value="daily">Day</option>
                      <option value="hourly">Hour</option>
                    </select><br />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-right">
                        Start Date:
                    </div>
                    <div className="col-md-6 text-left">
                        <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleStartDateChange} selected={this.state.selected_start_date}/>
                   </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-right">
                        End Date:
                    </div>
                    <div className="col-md-6 text-left">
                        <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleEndDateChange} selected={this.state.selected_end_date}/>
                   </div>
                </div>
                <div className="row">
                    <div className="col-md-6 text-right">&nbsp;</div>
                    <div className="col-md-6 text-left">
                    <button className="btn btn-sm btn-primary"
                      onClick={(e) => {
                        this.handleAddNewTradeplateFormSubmitButtonClick(e)
                      }}>
                      <i className="fa fa-plus"></i> Add New Tradeplate</button>
                    </div>
                </div>
              </fieldset>
            </form>
          </Animate>
          :'')}

            <ThisDriversCurrentTradeplates
               tradeplateAccountId={
                 this.state.data.driver.tradeplate_account_id
               }
               handleTotalAmountUpdate={this.handleTotalAmountUpdate}
               handlePaidAmountUpdate={this.handlePaidAmountUpdate}
               ref="child"
             />
          </div>

          <div className="col-md-6">
            <h2>Archived Tradeplaterentals</h2>
            <ThisDriversArchivedTradeplates
              tradeplateAccountId={
                this.state.data.driver.tradeplate_account_id
              }
               handleTotalAmountUpdate={this.handleTotalAmountUpdate}
               handlePaidAmountUpdate={this.handlePaidAmountUpdate}
               ref="child"
            />
          </div>
          </div>
        </div>
      </div>
    );
  }
}
